<template>
  <div class="ancap-rating-score" v-if="ANCAPdataExists">
    <div class="ancap-orange-box">
      <span class="ancap-tested d-block">Tested</span>
      <span class="ancap-year d-block" v-text="new Date(dateTested).getFullYear() || 'N/A'" />
    </div>

    <StarRating :stars="Number(ancapScore)" />
  </div>
  <div v-else class="ancap-rating-score--no-data">Current rating not available</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import StarRating from '../global/StarRating.vue';

const props = withDefaults(
  defineProps<{
    ancapScore: string | number;
    dateTested: string;
  }>(),
  { dateTested: '' }
);

const ANCAPdataExists = computed(() => {
  return props.dateTested && props.ancapScore !== 'N/A';
});
</script>

<style lang="scss" scoped>
.ancap-rating {
  margin-top: 0.1rem;
  padding-bottom: 1.25rem;
  max-height: 8rem;

  &-score {
    display: flex;
    align-items: center;
    gap: 1rem;
    border: 1px solid $ancap-orange;
    width: min-content;
    padding-right: 1rem;

    &--no-data {
      height: 3rem;
    }

    .ancap-orange-box {
      text-align: center;
      text-transform: uppercase;
      background: $ancap-orange;
      padding: 0.25rem 1.25rem;
    }

    .ancap-tested {
      font-size: 0.75rem;
      line-height: 1;
    }

    .ancap-year {
      font-family: $firasans-bold-font;
      font-size: 1.125rem;
    }
  }
}

.compact.ancap-rating-score {
  .ancap-orange-box {
    padding: 0.5rem 0.5rem 0.25rem;
  }
  .ancap-tested {
    font-size: 0.5rem;
    line-height: 0.5;
  }

  .ancap-year {
    font-size: 1rem;
  }
}
</style>
